export const createIdFromSlugAndId = (name?: string, id?: string | number) =>
  `${name?.toLocaleLowerCase().replace(/\s/g, '-')}-${id}`
